import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Provider } from './provider.model';
import { ProviderService } from './provider.service';

@Injectable()
export class PartyListGuard implements Resolve<Provider> {

  constructor(private providerService: ProviderService) { }

  resolve(route: ActivatedRouteSnapshot) {
    return this.providerService.getPartyList();
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/provider/party-list.guard.ts